module.exports = __webpack_public_path__ + "static/irresistible-f5ce2339bd358ab6a68185c26e0496ac.jpg";